import { Box, Theme } from '@mui/material';
import { NavMenuItem } from '../../../lib/constants/nav-menu-data';
import Authorized from '../../../lib/middlewares/Authorized';
import NavItem from './NavItem';
import navMenuHandler from '../../../lib/helper/nav-menu-handler';
import { useEffect, useState } from 'react';

export type NavMenuProps = {
    data: NavMenuItem[];
};

/**
 * Navigation menu for the DocApp
 */
const NavMenu = () => {
    const [data, setData] = useState<(JSX.Element | undefined)[]>();

    useEffect(() => {
        navMenuHandler(NavItem).then((data) => {
            setData(data);
        });
    }, []);

    return (
        <Box sx={styles}>
            <Authorized>{data}</Authorized>
        </Box>
    );
};

const styles = (t: Theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 2
});

export default NavMenu;
